module.exports = __webpack_public_path__ + "static/media/20ECE12.012d1d76.jpg";